import { Alert } from 'react-bootstrap'
import { Center } from '../../../../../components/Center'
import { CustomSpinner } from '../../../../../components/CustomSpinner'

export function LoaderWMS({ children, isLoading, message = 'Carregando...' }) {
  return isLoading ? (
    <Alert variant="info">
      <Center>
        <CustomSpinner size={28} />
        {message}
      </Center>
    </Alert>
  ) : (
    children
  )
}
